export const GROUP_BOOKS_CONSOLIDATION_ONE_TIME =
  "GROUP_BOOKS_CONSOLIDATION_ONE_TIME";
export const US_BOOKKEEPING_ONE_TIME = "US_BOOKKEEPING_ONE_TIME";
export const US_BOOKKEEPING_SUBSCRIPTION_PARENT =
  "US_BOOKKEEPING_SUBSCRIPTION_PARENT";
export const US_BOOKKEEPING_SUBSCRIPTION_SUB_TASK =
  "US_BOOKKEEPING_SUBSCRIPTION_SUB_TASK";
export const GAAP_FINANCIALS = "GAAP_FINANCIALS";
export const AUDIT = "AUDIT";
export const FINANCIAL_MODELLING = "FINANCIAL_MODELLING";
export const HISTORICAL_CLEANUP = "HISTORICAL_CLEANUP";
export const GROUP_BOOKS_CONSOLIDATION_RECURRING = "GROUP_BOOKS_CONSOLIDATION";
export const PAY_AS_YOU_GO_ANNUAL_BOOKKEEPING =
  "PAY_AS_YOU_GO_ANNUAL_BOOKKEEPING";
export const PRO_MONTHLY_BOOKKEEPING = "PRO_MONTHLY_BOOKKEEPING";
export const FORM_1099_AND_W_SERIES = "FORM_1099_AND_W_SERIES";
export const PAN_CARD_APPLICATION = "PAN_CARD_APPLICATION";
export const TP_PAYMENTS_ONBOARDING = "TP_PAYMENTS_ONBOARDING";
export const STATE_FRANCHISE_TAX_DELAWARE = "STATE_FRANCHISE_TAX_DELAWARE";
export const STATE_FILING_CALIFORNIA = "STATE_FILING_CALIFORNIA";
export const AD_HOC = "AD_HOC";
export const US_HOLDCO_INCORPORATION = "US_HOLDCO_INCORPORATION";
export const US_SUBSIDARY_INCORPORATION = "US_SUBSIDARY_INCORPORATION";
export const DISSOLUTION = "DISSOLUTION";
export const FORM_5471_FOREIGN_SUBSIDIARY_REPORTING =
  "FORM_5471_FOREIGN_SUBSIDIARY_REPORTING";
export const FORM_5472_REPORTABLE_TRANSACTIONS =
  "FORM_5472_REPORTABLE_TRANSACTIONS";
export const MONTHLY_BOOKKEEPING = "MONTHLY_BOOKKEEPING";
export const MONTHLY_BOOKKEEPING_SUB_TASK = "MONTHLY_BOOKKEEPING_SUB_TASK";
export const YEARLY_ADVANCE_TAX = "YEARLY_ADVANCE_TAX";
export const QUARTERLY_ADVANCE_TAX = "QUARTERLY_ADVANCE_TAX";
export const STATE_FILING = "STATE_FILING";
export const STATE_WITHDRAWAL = "STATE_WITHDRAWAL";
export const STATE_REGISTRATION_PAYROLL = "STATE_REGISTRATION_PAYROLL";
export const FOREIGN_QUALIFICATION = "FOREIGN_QUALIFICATION";
export const STATE_ANNUAL_REPORTS = "STATE_ANNUAL_REPORTS";
export const SALES_TAX_REGISTRATION = "SALES_TAX_REGISTRATION";
export const AUDIT_R_AND_D = "AUDIT_R&D";

export type ServiceType =
  | typeof GROUP_BOOKS_CONSOLIDATION_ONE_TIME
  | typeof GAAP_FINANCIALS
  | typeof AUDIT
  | typeof FINANCIAL_MODELLING
  | typeof GROUP_BOOKS_CONSOLIDATION_RECURRING
  | typeof PAY_AS_YOU_GO_ANNUAL_BOOKKEEPING
  | typeof PRO_MONTHLY_BOOKKEEPING
  | typeof PAN_CARD_APPLICATION
  | typeof TP_PAYMENTS_ONBOARDING
  | typeof US_BOOKKEEPING_ONE_TIME
  | typeof US_BOOKKEEPING_SUBSCRIPTION_PARENT
  | typeof US_BOOKKEEPING_SUBSCRIPTION_SUB_TASK
  | typeof US_HOLDCO_INCORPORATION;
